export default {
    "CRM_CONVERSATIONS_TRIGGER_LINKS_MODAL": {
        "path": "conversationsUtilitiesApp/LinkModal",
        "vue3": "conversationsUtilitiesApp/vue3"
    },
    "CRM_CONVERSATIONS_SNIPPETS_TEXT_SNIPPET_MODAL": {
        "path": "conversationsUtilitiesApp/TextSnippetModal",
        "vue3": "conversationsUtilitiesApp/vue3"
    },
    "CRM_CONVERSATIONS_SNIPPETS_EMAIL_SNIPPET_MODAL": {
        "path": "conversationsUtilitiesApp/EmailSnippetModal",
        "vue3": "conversationsUtilitiesApp/vue3"
    }
}